const reloadIfRestoredFromBfCache = () => {
	window.addEventListener('pageshow', event => {
		if (event.persisted) {
			console.log('Restored from bfcache. Will reload.');
			location.reload();
		}
	});
};

export default reloadIfRestoredFromBfCache;